import React, {ReactNode} from "react";
import {StoryCrafter} from "./crafter/StoryCrafter";
import {Graphs} from "./graph/Graphs";
import {Notes} from "./notes/Notes";
import {Outlines} from "./outline/Outline";
import {Files} from "./files/Files";
import {Script} from "./scriptwriting/Script";

export interface StoryTool {
    id: string,
    name: string,
    icon: React.ReactNode,
    enabled: boolean,
    entryPoint: React.ReactNode,
    link: (projectId?: string, storyId?: string) => string,
    paths: string[],
}

export const storyTools: StoryTool[] = [
    new Files(),
    new Graphs(),
    new StoryCrafter(),
    new Notes(),
    new Outlines(),
    new Script()
]